module.exports = {
  SLOW: 'slow',
  QUICK: 'quick',
};
